import agenticImg from '../Assert/2.png';
import useDocumentTitle from '../hooks/useDocumentTitle';

const understandingImg = require('../Assert/13.jpg');

function AgenticAI() {
  useDocumentTitle('Agentic AI Systems — MMI');

  return (
    <main className="agentic-page">
      {/* Hero Section - Two Column Layout with Image */}
      <section className="agentic-hero">
        <div className="container">
          <div className="hero-two-column">
            {/* Left Column - Text */}
            <div className="hero-left">
              <h1 className="hero-title">
                AI That Doesn't Just <span className="gradient-text">Answer.</span>
                <br />
                <span className="gradient-text">It Acts.</span>
              </h1>
              <p className="hero-description">
                Move beyond chatbots. Deploy autonomous agents that execute complex 
                workflows and solve real business problems.
              </p>
            </div>
            {/* Right Column - Image */}
            <div className="hero-right">
              <figure className="agentic-illustration-card" aria-hidden>
                <div className="hero-media">
                  <video
                    className="hero-video"
                    autoPlay
                    muted
                    loop
                    playsInline
                    poster={agenticImg}
                  >
                    <source src="/videos/agentic.mp4" type="video/mp4" />
                  </video>
                </div>
                <div className="agentic-node-pulse" />
                <div className="agentic-node-sparks" />
              </figure>
            </div>
          </div>
        </div>
      </section>

      {/* Understanding Section */}
      <section className="understanding-section">
        <div className="container">
          <div className="understanding-wrapper">
            <div className="understanding-content">
              <h2 className="understanding-heading">
                What <span className="gradient-text">Agentic AI</span> Actually Means
              </h2>
              <div className="understanding-text">
                <p>
                  Agentic AI represents a paradigm shift from passive assistants to 
                  proactive problem solvers. These systems aren't just predicting 
                  the next word; they are determining the next logical action to 
                  achieve a goal.
                </p>
                <p>
                  By leveraging self-correcting feedback loops and tool-use capabilities, 
                  autonomous agents can navigate ambiguous tasks, interface with 
                  third-party software, and manage long-term objectives without constant 
                  human prompting.
                </p>
                <p className="highlight-para">
                  This is the future of digital efficiency — where AI acts as an extension 
                  of your workforce, capable of reason, tool manipulation, and independent 
                  decision-making.
                </p>
              </div>
            </div>
            <div className="understanding-media">
              <div className="assert-image-wrap">
                <img src={understandingImg} alt="Understanding agentic AI" className="assert-image" />
                <div className="assert-image-glow" aria-hidden="true" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services / Offerings Section */}
      <section className="services-section">
        <div className="container">
          <div className="services-label">CAPABILITIES</div>
          <div className="services-grid" aria-label="Agentic AI services">
            <div className="service-offer-card reveal-up" style={{ '--reveal-delay': '0ms' }}>
              <div className="service-offer-num">01</div>
              <h3 className="service-offer-title">AI Agents</h3>
            </div>
            <div className="service-offer-card reveal-up" style={{ '--reveal-delay': '120ms' }}>
              <div className="service-offer-num">02</div>
              <h3 className="service-offer-title">Multi-Agent Systems</h3>
            </div>
            <div className="service-offer-card reveal-up" style={{ '--reveal-delay': '240ms' }}>
              <div className="service-offer-num">03</div>
              <h3 className="service-offer-title">AI Copilots</h3>
            </div>
            <div className="service-offer-card reveal-up" style={{ '--reveal-delay': '360ms' }}>
              <div className="service-offer-num">04</div>
              <h3 className="service-offer-title">RAG Systems</h3>
            </div>
            <div className="service-offer-card reveal-up" style={{ '--reveal-delay': '480ms' }}>
              <div className="service-offer-num">05</div>
              <h3 className="service-offer-title">Workflow Automation</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section - Animated Cards */}
      <section className="process-section">
        <div className="container">
          <h2 className="process-heading">
            Process to <span className="gradient-text">Build</span>
          </h2>

          <div className="process-cards-grid">
            {/* Card 1 */}
            <div className="process-card reveal-up" style={{ '--reveal-delay': '0ms' }}>
              <div className="process-card-number">1</div>
              <h3 className="process-card-title">We listen to your data</h3>
              <p className="process-card-desc">
                Understand goals, constraints, and where autonomy adds real value.
              </p>
            </div>

            {/* Card 2 */}
            <div className="process-card reveal-up" style={{ '--reveal-delay': '120ms' }}>
              <div className="process-card-number">2</div>
              <h3 className="process-card-title">We build the knowledge layer</h3>
              <p className="process-card-desc">
                Ingest, structure, and index the information agents need to act.
              </p>
            </div>

            {/* Card 3 */}
            <div className="process-card reveal-up" style={{ '--reveal-delay': '240ms' }}>
              <div className="process-card-number">3</div>
              <h3 className="process-card-title">We map context and constraints</h3>
              <p className="process-card-desc">
                Define guardrails, tools, and decision boundaries for reliability.
              </p>
            </div>

            {/* Card 4 */}
            <div className="process-card reveal-up" style={{ '--reveal-delay': '360ms' }}>
              <div className="process-card-number">4</div>
              <h3 className="process-card-title">The system learns to decide</h3>
              <p className="process-card-desc">
                Iterate, test, and refine agent behaviors until outcomes are consistent.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default AgenticAI;